import CheckZip from '../Component/CheckZip';

import { connect } from 'react-redux';
import * as actions from '../../../Actions';

const mapStateToProps = (state) => {
  return {
    ZipcodeCheck: state.zipcodeCheck,
    enquiry: state.enquiry,
  };
};

const mapDispatchToProps = {
  checkZipCode: actions.checkZipCode,
  nonServiceableEnquiry: actions.nonServiceableEnquiry,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckZip);
